import script from "./CInputNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./CInputNumber.vue?vue&type=script&setup=true&lang=ts"

import "./CInputNumber.vue?vue&type=style&index=0&id=59f45e2e&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f45e2e"]])

export default __exports__